// Import jQuery once
import $ from 'jquery';

// Expose the same instance globally
window.$ = window.jQuery = $;

require("./home/plugins.js");
require("../vendors/broccoli/js/main.js");
import "../styles/home/style.scss";
/*-------------------------------------------------------------
  1. Avoid `console` errors in browsers that lack a console.
---------------------------------------------------------------*/
(function() {
    var method;
    var noop = function () {};
    var methods = [
      'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
      'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
      'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
      'timeline', 'timelineEnd', 'timeStamp', 'trace', 'warn'
    ];
    var length = methods.length;
    var console = (window.console = window.console || {});
  
    while (length--) {
      method = methods[length];
  
      // Only stub undefined methods.
      if (!console[method]) {
        console[method] = noop;
      }
    }
  }());


/* --------------------------------------------------------
    3. Slider One Active 
--------------------------------------------------------- */
$('.ltn__slide-auto').slick({
    autoplay: true,
    autoplaySpeed: 10000,
    arrows: false,
    dots: true,
    fade: true,
    cssEase: 'linear',
    infinite: true,
    speed: 300,
    swipe: false,
    slidesToShow: 1,
    slidesToScroll: 1,
}).on('afterChange', function(){
    new WOW().init();
});